
import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  
  const createho006 = {
    label: "Create Fort Night",
    pageLabel: "Create Fort Night",
    starting: true,
    url: "createho006",
    pageType: "history",
    form: [
        {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "From Date",
            name: "",
            description: "Enter From Date"
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "From Date",
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            name: "FromDate",
            description: "Enter From Date"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "To Date",
            name: "",
            description: "Enter To Date"
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "To Date",
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            name: "ToDate",
            description: "Enter To Date"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Last Firday",
            name: "",
            description: "Enter Last Firday"
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Last Firday",
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            name: "LastFirday",
            description: "Enter Last Firday"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "TDL",
            name: "",
            description: "Enter TDL"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "TDL",
            name: "TDL",
            description: "Enter TDL"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "TDL(100)",
            name: "",
            description: "Enter TDL(100)"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "TDL(100)",
            name: "TDL_100",
            description: "Enter TDL(100)"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "TDL(1000)",
            name: "",
            description: "Enter TDL(1000)"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "TDL(1000)",
            name: "TDL_1000",
            description: "Enter TDL(1000)"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "TDL(10000)",
            name: "",
            description: "Enter TDL(10000)"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "TDL(10000)",
            name: "TDL_10000",
            description: "Enter TDL(10000)"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "TDL(100000)",
            name: "",
            description: "Enter TDL(100000)"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "TDL(100000)",
            name: "TDL_100000",
            description: "Enter TDL(100000)"
          },
    ]
  }
  export default createho006;